export const environment = {
  production: true,
  name: 'PRODUCTION',
  baseUrl: 'https://api.rapidrent.com/',
  webSocketBaseUrl: 'wss://ws.rapidrent.com/cable?token=',
  kioskUrl: 'http://localhost:4567/',
  kiosk: true,
  version: '2.1.4'
}
